import { DI } from '@microsoft/fast-foundation';
/**
 * Types of Genesis resources.
 * @public
 */
export var ResourceType;
(function (ResourceType) {
    ResourceType["DATASERVER"] = "DATASERVER";
    ResourceType["EVENT_HANDLER"] = "EVENT_HANDLER";
    ResourceType["REQUEST_SERVER"] = "REQUEST_SERVER";
})(ResourceType || (ResourceType = {}));
/**
 * Default values for a DatasourceConfig
 * @public
 */
export class DatasourceDefaults {
}
DatasourceDefaults.MAX_ROWS_250 = 250;
DatasourceDefaults.MAX_VIEW_1000 = 1000;
DatasourceDefaults.REQ_REP_POLLING_INTERVAL_MS = 10000;
DatasourceDefaults.DATASERVER_ROW_ID = 'ROW_REF';
DatasourceDefaults.REQUEST_SERVER_ROW_ID = 'RECORD_ID';
/**
 * The DI token for the DatasourceConfig interface.
 *
 * @privateRemarks
 * Marked as internal to stop api-extractor becoming confused cross-linking tokens with the same name.
 *
 * @internal
 */
export const DatasourceConfig = DI.createInterface();
